import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const BobLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. What is the highest loan amount that may be obtained while studying abroad?",
            content: "The loan amount you are eligible for is determined by the status of your university on the leading list. If your institution is included in the premier list, you may qualify for a maximum loan amount of 1.5 Crore. However, if your university is not on the list, the maximum loan amount available to you is 60 Lakh."
        },
        {
            title: "2. Are tax benefits available for BOB education loans?",
            content: "Yes, section 80e tax advantages are available for the BOB education loan."
        },
        {
            title: "3. What is the duration of a BOB education loan?",
            content: "The duration of a BOB education loan can be as long as 15 years."
        },
        {
            title: "4. Does a BOB education loan have a prepayment penalty?",
            content: "BOB education loans do not have a prepayment penalty. You can pay off your education loan early if you can. There are no extra fees for closing your education loan ahead of schedule."
        }, {
            title: "5. How much margin money is required for a BOB education loan?",
            content: "The margin requirements for BOB education loans differ depending on the type of institution. For top-tier institutions, loans up to Rs 4.00 lakh do not require any margin, while loans ranging from above Rs 4.00 lakh up to Rs 7.50 lakh have a 15% margin. However, loans above Rs 7.50 lakh in top-tier institutions do not want any margin. On the other hand, for non-top-tier institutions, loans up to Rs 4.00 lakh do not need a margin, loans above Rs 4.00 lakh up to Rs 7.50 lakh have a 15% margin, and loans above Rs 7.50 lakh require a 10% margin."
        },
        {
            title: "6. What is the BOB education loan interest rate?",
            content: "The interest rate you are eligible for is determined by whether your institution is considered a premier institution and the amount of loan you want to borrow. If your institution is on the premier list, you can get a loan with an interest rate of 9.7%. However, if your institution is not on the premier list, loans up to 7.5 lakh can be given at an interest rate of 11.15%, while loans exceeding 7.5 lakh can be provided at a rate of 10.20%."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"BOB Education Loan"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"BOB Education Loan"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">BOB Education Loan for Abroad Studies</h5>
                            <p className="loan-elegibility-des">Founded on July 20, 1908, the Bank of Baroda (BOB) is a state-owned banking and financial services company based in Gujarat, India, with its main office in Vadodara (formerly Baroda). The Government implemented the ‘Alternative Mechanism’ scheme on April 1, 2019, which involved merging Vijaya Bank and Dena Bank with Bank of Baroda. The Bank of Baroda offers many education loan programs, such as Baroda Scholar, Baroda Digital Education Loan, Baroda Vidya, and Baroda Gyan, among many more.
                                <br /><br />
                                The primary emphasis on this page is placed on the Baroda Scholar program, which provides financial support to Indian students pursuing their education abroad. This scheme aids students fulfill their dreams of studying overseas by offering them the necessary funds.</p>
                            <h5 className="about-head">Features of BOB Education Loan</h5>
                            <p className="loan-elegibility-des">This BOB education loan table contains important information regarding loan amounts, interest rates, fees, and loan terms.</p>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Description	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            9.7% (Fixed)
                                            (0.20% concession for female applicants of non-premier institutes)

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">

                                            7.5 Lakh INR - 1.5 Cr INR

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Margin money</td>
                                        <td className="">

                                            0-15%

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Property evaluation charges</td>

                                        <td className="">8,500 INR</td>

                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing fees</td>
                                        <td className="">

                                            INR 10,000 + GST (Refundable)

                                        </td>


                                    </tr>

                                    <tr>
                                        <td>
                                            Moratorium Period</td>
                                        <td>Course duration + 12 months</td></tr>
                                    <tr>
                                        <td>Repayment tenure</td>
                                        <td>10-15 years</td>
                                    </tr>
                                </tbody>
                            </table>

                            <h5 className="about-head mb-4">Criteria for qualifying for Bank of Baroda Education Loan</h5>
                            <p className="loan-elegibility-des">The student needs to be at least 18 years old and an Indian citizen.
                                <br /><br />
                                The scholar must have been accepted into a reliable university for a professional or technical program through merit or entrance-based selection process.
                                <br /><br />
                                Your institution needs to be included in the list created by the Bank of Baroda to receive a loan.
                                <br /><br />
                                The lending institution requires the applicant to possess a consistently impressive academic track record and meet the minimum academic requirements. Additionally, the student must complete any necessary prerequisite exams, such as the GRE, IELTS, or TOEFL.</p>


                            <h5 className="about-head">Documents needed for Bank of Baroda’s Education Loan</h5>
                            <p className="loan-elegibility-des">The essential documentation for a BOB education loan for pursuing overseas studies may differ based on various factors. These factors primarily revolve around your academic and professional background, the financial and credit history of your co-applicant, and the specific location of the property or asset that you intend to utilize as collateral.</p>


                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">

                            <h5 className="about-head">Documents needed in the first stage of the loan application procedure</h5>
                            <h6 className="subhead mt-4">Candidates' documents</h6>
                            <ol className="subhead-ul">
                                <li><b>Identity proof :</b> Passport/ PAN/ Driver’s License/ Voter ID card or government-issued identification document.</li>
                                <li><b>Address proof :</b> recent copy of piped gas bill/ telephone bill/ electricity bill/water bill/ driving license/ Aadhaar card.</li>
                                <li>Passport Mandatory (in case of study abroad).</li>
                                <li>Past academic record.
                                    <ol>
                                        <li>Undergraduate result (semester-wise)</li>
                                        <li>12th standard mark sheet</li>
                                        <li>10th standard mark sheet</li>
                                    </ol>
                                </li>

                                <li>Entrance Exam Result (e.g. CAT, CMAT, JEE, NEET, CET, GMAT, GRE, etc. for domestic institutes)</li>
                                <li>Entrance Exam Result (e.g. GMAT, GRE, TOEFL, etc. for abroad study)</li>
                                <li>Proof of admission: admission letter (A conditional admission letter is also applicable).</li>
                                <li>Statement of cost/expenses.</li>
                                <li>Loan A/C statement of one year, if there is any previous loan from other Banks/ Lenders.</li>
                                <li>2 passport-size photographs.</li>
                            </ol>
                            <h6 className="subhead">Co-applicants Documents</h6>
                            <ol className="subhead-ul">

                                <li><b>Identity proof :</b> Passport/ PAN/ Driver’s license/ Government-issued identification document or Voter ID card.</li>
                                <li>2 passport-size photographs.</li>
                                <li><b>Address :</b> recent copy of electricity bill/ telephone bill/ water bill/ piped gas bill or copy of passport/ Aadhaar card/driving license</li>
                                <li>Legal documents of the collateral/ property documents</li>
                                <li>If any previous loan is from other banks/ lenders, then the loan A/C statement of 1 year.</li>
                                <li>Bank account statement of the co-borrower/guarantor, for the last 6 months (in case of takeover of education loan).</li>
                            </ol>
                            <h6 className="subhead">Proof of Income is Required for a Co-applicant/Guarantor who is Employed.</h6>
                            <ol className="subhead-ul">
                                <li>Copy of Form 16 of the last 2 years or copy.</li>
                                <li>Salary slips for the last 3 months</li>
                                <li>Brief statement of assets & liabilities of parent/ guardian/ other co-borrower.</li>
                                <li>Bank account statement for the last 6 months (Salary account).</li>

                            </ol>
                            <h6 className="subhead">Proof of Income Needed for Self-employed Co-applicant/Guarantor</h6>
                            <ol className="subhead-ul">
                                <li>Last 2 years IT returns (If IT Payee)</li>
                                <li>Proof of business address</li>
                                <li>TDS certificate (Form 16A, if applicable)</li>
                                <li>Certificate of qualification (for C.A./ doctor and other professionals)</li>
                                <li>Brief statement of assets & liabilities of parent/ guardian/ other co-borrower</li>
                                <li>Statement of bank accounts within the last six months</li>
                            </ol>
                            <h5 className="about-head">How To Get Approved for A BOB Education Loan Through Credere?</h5>
                            <p className="loan-elegibility-des">You may apply on their website if you’re looking to get a BOB loan for overseas education. On the other hand, applying for your education loan through Credere offers a smoother application process.
                                <br /><br />
                                Credere is a digital platform intended to help Indian students pay for their higher education abroad. All you have to do to start the process with us is determine your loan eligibility; we’ll handle the rest!</p>


                            <h5 className="about-head">Secure your education loan from BOB through Credere</h5>


                            <p className="loan-elegibility-des"><b>Loan With a Guaranteed Best Rate</b></p>

                            <p className="loan-elegibility-des">Credere commits to providing you with the most competitive education loan in the marketplace at the lowest possible rate. We work tirelessly to give you the greatest offer. </p>



                            <p className="loan-elegibility-des"><b>Completely Free Services Available</b></p>

                            <p className="loan-elegibility-des">  The services offered to applicants by Credere are entirely free. There are no fees associated with the BOB abroad education loan application process. </p>

                            <p className="loan-elegibility-des"><b>Fast Processing Time</b></p>

                            <p className="loan-elegibility-des"> Our staff interacts with several BOB departments to quicken the loan approval process, which generally requires 15 to 20 days when you request an education loan through Credere. For this reason, we receive thousands of student loan applications each year. The normal loan processing time frame at BOB is between 30 and 45 days if a student applies straight to the bank.</p>

                            <p className="loan-elegibility-des"><b>Greater Probability of Approval</b></p>


                            <p className="loan-elegibility-des">  If documents are missing, property-related problems or additional issues arise, we rapidly communicate with BOB officials to solve these. This ensures quick settlement of issues and significantly improves your chances of being approved for a BOB education loan. Credere is committed to offering continuous support and assistance in case you face any challenges or hurdles. </p>

                            <p className="loan-elegibility-des"><b>Challenges in BOB Education Loan </b></p>


                            <p className="loan-elegibility-des">  To speed up your education loan application, we outline a few obstacles that you should be aware of below, along with solutions. </p>
                            <p className="loan-elegibility-des"><b>Delay in the Procedural Process</b></p>


                            <p className="loan-elegibility-des"> Typically, individuals submit their applications to a specific branch of the Bank of Baroda. The majority of branches do not have the authority to approve or reject education loan applications. The main responsibility of the branch is to gather the required paperwork in time and send your applications to the Specialized Mortgage Store (SMS), a specialized back-end office. This particular office is responsible for the comprehensive evaluation of the loan application.</p>
                            <p className="loan-elegibility-des"><b>Challenges and Complications Related to the Property’s Legal Aspects</b></p>


                            <p className="loan-elegibility-des"> Bank of Baroda impanelled advocates to verify the property of the applicant and its supporting legal papers for the loan to be sanctioned. Nevertheless, the bank and advocates have a high Turnaround Time (TAT), meaning that there is a tendency for officials to prolong the verification process when discrepancies are found in property or related documents.
                                <br /><br />
                                Credere is your ultimate savior in situations like these, as we collaborate with the bank to explore alternative solutions when faced with such challenges. Credere has a well-established history of assisting numerous students in overcoming challenges related to property or document issues, ensuring that these obstacles do not hinder their ability to secure an education loan.  </p>
                            <p className="loan-elegibility-des"><b>Issues Related to Property’s Technical Aspects</b></p>


                            <p className="loan-elegibility-des">  The thorough evaluation of the applicant’s property, conducted by Civil Engineers appointed by BoB, is a highly extensive and time-consuming process. After visiting the property, civil engineers measure it, determine its age and location, and figure out its fair price, market price, and distress sale price. The Civil Engineer’s Turnaround Time (TAT) can often be long and uncertain, but our systematic approach ensures completion within three business days. </p>
                            <p className="loan-elegibility-des"><b>Problems with Pre-visa Allocation</b></p>


                            <p className="loan-elegibility-des"> Apart from the solutions mentioned earlier, Credere also guarantees the pre-visa disbursement of loans. This means that we ensure the bank releases the loan to the applicant before the issuance of their visa.</p>





                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default BobLendingPartner;